import {
    httpStoreProjectMainPathologies,
    HttpStoreProjectMainPathologiesOptions
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'

export const useStoreProjectMainPathologies = ({
    urlParams,
    options
}: {
    urlParams: HttpStoreProjectMainPathologiesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpStoreProjectMainPathologiesOptions['payload']>
}) =>
    useMutation({
        ...options,
        mutationFn: payload => httpStoreProjectMainPathologies({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
